export default {
  "app": {
    "terms_and_conditions": "terms & conditions",
    "privacy_policy": "privacy policy",
    "acceptable_policy": "acceptable use policy"
  },
  "spotlight": {
    "emptyState": "Recherchez n'importe quel objet dans votre espace de travail!",
    "noResults": {
      "title": "Aucun résultat trouvé",
      "description": "Essayez d'ajuster votre recherche ou vos filtres pour trouver ce que vous cherchez."
    }
  }
};
